/** The full inbox, a shell page (every tenant, every staff user, no tile). */
export const NOTIFICATIONS_PATH = '/notifications';
